import { apiClient } from '@/plugins/axios'; // Import your axios instance


const getPreferences = async (filters: Record<string, any> = {}) => {
  const params = new URLSearchParams(filters as any); // Convert filters into query params
  return await apiClient.get('/preferences?' + params.toString()); // Fetch paginated listings
};

const getPreferenceById = async (id: number) => {
  return await apiClient.get(`/preferences/${id}`); // Fetch car listing by ID
};

const createPreference = async (preferencesData: any) => {
  return await apiClient.post('/preferences', preferencesData); // Create a new car listing
};

const updatePreferences = async (id: number, preferencesData: any) => {
  return await apiClient.patch(`/preferences/${id}`, preferencesData); // Update car listing by ID
};

const deletePreference = async (id: number) => {
  return await apiClient.delete(`/preferences/${id}`); // Delete car listing by ID
};

export default {
  getPreferences,
  getPreferenceById,
  createPreference,
  updatePreferences,
  deletePreference,
};
